export default "__VITE_ASSET__5bEvLaRG__"